<template>
  <div>
    <!-- block -->
    <div class="block mt-4">
      <h1>Matic Krajnc</h1>
    </div>
    <!-- ./ block -->

    <!-- quick info -->
    <AboutTable />
    <!-- ./ quick info -->

    <hr />

    <div class="text-center">
      <img src="/img/my-profile-pic.jpg" class="img-fluid" />
    </div>

    <div class="block">
      <h5>What do you do at *YOUR COMPANY*?</h5>
      <p>
        With previous experience on APIs and payment systems I was assigned in
        the Engineering team to work on building new products from scratch and
        designing and coding the architecture of our core systems and
        micro-services.
      </p>

      <h5>What are your thoughts on remote work?</h5>
      <p>
        I have worked remotely before and I always loved it. Working from home
        gives me freedom to self-organize and choose the best time to be
        productive.
      </p>
      <p>
        I have my home office setup with a standing desk, dual monitors and a
        kick-ass PC (and laptop) in my bedroom to stay isolated from
        interuptions from my children - when I need to. Fitness and outdoor
        activities also help with concentration so I try to exercise regularly.
      </p>

      <h5>What do you like about *YOUR COMPANY*?</h5>
      <p>
        That you operate based on trust. I find this one of the most important
        values to build a team around.
      </p>

      <h5>Anything else you want to say?</h5>
      <p>
        Look Mom, I made it! 🤭
      </p>
    </div>
  </div>
</template>

<script>
import AboutTable from '@/components/AboutTable'

export default {
  name: 'TeamMember',
  components: { AboutTable }
}
</script>

<style></style>
